import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LogoutModal from "./logoutModal/LogoutModal";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";

export default function LogoutButton({
  padding,
  context,
  className,
  menu,
  iconSize,
}: any) {
  const { t } = useTranslation("common");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    return () => {
      setOpen(false);
    };
  }, []);

  return (
    <>
      <ListItem
        sx={{ opacity: 0.5, cursor: "pointer" }}
        onClick={() => {
          setOpen(true);
        }}
        className={className}
      >
        <ListItemIcon sx={{ pl: padding }}>
          <LogoutRoundedIcon />
        </ListItemIcon>
        <ListItemText primary={t("logout.logout")} />
      </ListItem>
      {open && <LogoutModal open={open} close={() => setOpen(false)} />}
    </>
  );
}
